module.exports = __webpack_public_path__ + "img/place_rosemere.1842a9ec.webp";